import React from "react";
import DashboardLayout from "../components/DashboardLayout";

function Logistics() {
  return (
    <DashboardLayout headerTitle="Logistics">
      <div className="mt-[20px] text-center">Page Contents</div>
    </DashboardLayout>
  );
}

export default Logistics;
